import request from '../request.js'

// 获取项目数据 --- 查询所有 （晏阳）
const getProject = function (data) {
    return request({
        url: `/dataProject/getProject`,
        method: 'post',
        data
    })
}

// 筛选查询 获取项目数据 （晏阳）
const searchProject = function (data) {
    return request({
        url: '/dataProject/getProject',
        method: 'post',
        data
    })
}

// 保存项目（晏阳）
const saveProject = function (data) {
    return request({
        url: 'dataProject/insertProject',
        method: 'post',
        data
    })
}

// 获取项目数据（晏阳）
const getInfo = function (data) {
    return request({
        url: 'dataProject/getInfo',
        method: 'post',
        data
    })
}

// 更新项目（晏阳）
const updateProject = function (data) {
    return request({
        url: 'dataProject/updateProject',
        method: 'post',
        data
    })
}

// 删除项目（晏阳）
const deleteProject = function (data) {
    return request({
        url: 'dataProject/deleteProject',
        method: 'post',
        data
    })
}

// 初始化项目（晏阳）
const initProject = function (data) {
    return request({
        url: '/dataProject/initProject',
        method: 'post',
        data
    })
}

// 项目审核获取左侧项目列表数据 （叶凡）
const getAllProjects = function (data) {
    return request({
        url: 'dataProject/getAllProjects',
        method: 'post',
        data
    })
}

// 数据库管理-查询树结构数据
const selectModules = function (query) {
    return request({
        url: 'dataProjectMenu/getModulesByProjectId',
        method: 'post',
        data: query
    })
}

// 数据库管理-提交新的树结构数组
const updateAll = function (query) {
    return request({
        url: 'dataProjectMenu/updateAll',
        method: 'post',
        data: query
    })
}

// 数据库管理-获取数据库列表
const selectByMid = function (query) {
    return request({
        url: 'dataDbTb/getTableByMid',
        method: 'post',
        data: query
    })
}

export {
    getProject,
    getAllProjects,
    initProject,
    searchProject,
    saveProject,
    getInfo,
    updateProject,
    deleteProject,
    selectModules,
    updateAll,
    selectByMid,
}